import { useTranslation } from "react-i18next";

import { HelpAndPrivacyLinkItem } from "./HelpAndPrivacyLinkItem";

export function AboutCertn() {
  const { t } = useTranslation();
  return (
    <HelpAndPrivacyLinkItem
      testID="help-and-privacy-about-certn-view-button"
      item={t("About Certn")}
      description={t("Learn about us and our commitment to you")}
      linkText={t("View")}
      link="https://certn.co/about-certn/"
    />
  );
}
